import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import demoVideo from "@/assets/demo-lototerminal.mp4.asset.json";

interface HeroProps {
  onSignup: () => void;
}

const HeroSection = ({ onSignup }: HeroProps) => {
  const [demoOpen, setDemoOpen] = useState(false);
  return (
    <div className="mx-auto max-w-[760px] px-8 pb-[60px] pt-[72px] text-center">
      <div className="mb-10 inline-flex items-center gap-2 rounded-full border border-lt-gold-border bg-lt-gold-bg px-4 py-[5px] text-[11px] font-medium uppercase tracking-[0.14em] text-primary">
        <div className="h-[5px] w-[5px] rounded-full bg-primary" />
        TRANSFORME SEU JOGO EM DECISÃO INTELIGENTE
      </div>
      <h1 className="mb-2.5 font-serif text-[clamp(28px,5vw,66px)] font-light leading-[1.1] tracking-tight text-foreground">
        LotoTerminal — Inteligência e <em className="text-primary italic">análise</em> para loterias
      </h1>
      <p className="mb-10 font-serif text-[clamp(15px,2vw,20px)] font-light italic leading-relaxed text-lt-cream3">
        Pare de apostar no escuro. Dados e transparência para Mega-Sena, Lotofácil, Quina e Dupla Sena.
      </p>
      <div className="flex flex-wrap justify-center gap-3 mb-[60px]">
        <button
          onClick={onSignup}
          className="rounded-lg bg-primary px-[30px] py-[13px] font-sans text-sm font-medium text-primary-foreground transition-colors hover:opacity-90"
        >
          Começar gratuitamente
        </button>
        <button
          onClick={() => setDemoOpen(true)}
          className="rounded-lg border border-lt-border bg-transparent px-[30px] py-[13px] font-sans text-sm text-lt-cream2 transition-colors hover:border-lt-cream3"
        >
          Ver demonstração
        </button>
      </div>
      <Dialog open={demoOpen} onOpenChange={setDemoOpen}>
        <DialogContent className="max-w-4xl border-lt-border bg-lt-bg2 p-0 overflow-hidden">
          <DialogTitle className="sr-only">Demonstração do LotoTerminal</DialogTitle>
          {demoOpen && (
            <video
              src={demoVideo.url}
              controls
              autoPlay
              playsInline
              className="aspect-video w-full bg-black"
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default HeroSection;
